export const areaCodeToTimezoneMap = {
    "201": "Eastern Standard Time",
    "202": "Eastern Standard Time",
    "203": "Eastern Standard Time",
    "204": "Central Standard Time",
    "205": "Central Standard Time",
    "206": "Pacific Standard Time",
    "207": "Eastern Standard Time",
    "208": "Mountain Standard Time",
    "209": "Pacific Standard Time",
    "210": "Central Standard Time",
    "212": "Eastern Standard Time",
    "213": "Pacific Standard Time",
    "214": "Central Standard Time",
    "215": "Eastern Standard Time",
    "216": "Eastern Standard Time",
    "217": "Central Standard Time",
    "218": "Central Standard Time",
    "219": "Central Standard Time",
    "220": "Eastern Standard Time",
    "223": "Eastern Standard Time",
    "224": "Central Standard Time",
    "225": "Central Standard Time",
    "226": "Eastern Standard Time",
    "227": "Eastern Standard Time",
    "228": "Central Standard Time",
    "229": "Eastern Standard Time",
    "231": "Eastern Standard Time",
    "234": "Eastern Standard Time",
    "235": "Central Standard Time",
    "236": "Pacific Standard Time",
    "239": "Eastern Standard Time",
    "240": "Eastern Standard Time",
    "248": "Eastern Standard Time",
    "249": "Eastern Standard Time",
    "250": "Pacific Standard Time",
    "251": "Central Standard Time",
    "252": "Eastern Standard Time",
    "253": "Pacific Standard Time",
    "254": "Central Standard Time",
    "256": "Central Standard Time",
    "260": "Eastern Standard Time",
    "262": "Central Standard Time",
    "263": "Eastern Standard Time",
    "267": "Eastern Standard Time",
    "269": "Eastern Standard Time",
    "270": "Central Standard Time",
    "272": "Eastern Standard Time",
    "274": "Central Standard Time",
    "276": "Eastern Standard Time",
    "279": "Pacific Standard Time",
    "281": "Central Standard Time",
    "289": "Eastern Standard Time",
    "301": "Eastern Standard Time",
    "302": "Eastern Standard Time",
    "303": "Mountain Standard Time",
    "304": "Eastern Standard Time",
    "305": "Eastern Standard Time",
    "306": "Central Standard Time",
    "307": "Mountain Standard Time",
    "308": "Central Standard Time",
    "309": "Central Standard Time",
    "310": "Pacific Standard Time",
    "312": "Central Standard Time",
    "313": "Eastern Standard Time",
    "314": "Central Standard Time",
    "315": "Eastern Standard Time",
    "316": "Central Standard Time",
    "317": "Eastern Standard Time",
    "318": "Central Standard Time",
    "319": "Central Standard Time",
    "320": "Central Standard Time",
    "321": "Eastern Standard Time",
    "323": "Pacific Standard Time",
    "324": "Eastern Standard Time",
    "325": "Central Standard Time",
    "326": "Eastern Standard Time",
    "327": "Central Standard Time",
    "329": "Eastern Standard Time",
    "330": "Eastern Standard Time",
    "331": "Central Standard Time",
    "332": "Eastern Standard Time",
    "334": "Central Standard Time",
    "336": "Eastern Standard Time",
    "337": "Central Standard Time",
    "339": "Eastern Standard Time",
    "341": "Pacific Standard Time",
    "343": "Eastern Standard Time",
    "346": "Central Standard Time",
    "347": "Eastern Standard Time",
    "350": "Pacific Standard Time",
    "351": "Eastern Standard Time",
    "352": "Eastern Standard Time",
    "353": "Central Standard Time",
    "354": "Eastern Standard Time",
    "360": "Pacific Standard Time",
    "361": "Central Standard Time",
    "363": "Eastern Standard Time",
    "364": "Central Standard Time",
    "365": "Eastern Standard Time",
    "367": "Eastern Standard Time",
    "368": "Mountain Standard Time",
    "369": "Pacific Standard Time",
    "380": "Eastern Standard Time",
    "382": "Eastern Standard Time",
    "385": "Mountain Standard Time",
    "386": "Eastern Standard Time",
    "401": "Eastern Standard Time",
    "402": "Central Standard Time",
    "403": "Mountain Standard Time",
    "404": "Eastern Standard Time",
    "405": "Central Standard Time",
    "406": "Mountain Standard Time",
    "407": "Eastern Standard Time",
    "408": "Pacific Standard Time",
    "409": "Central Standard Time",
    "410": "Eastern Standard Time",
    "412": "Eastern Standard Time",
    "413": "Eastern Standard Time",
    "414": "Central Standard Time",
    "415": "Pacific Standard Time",
    "416": "Eastern Standard Time",
    "417": "Central Standard Time",
    "418": "Eastern Standard Time",
    "419": "Eastern Standard Time",
    "423": "Eastern Standard Time",
    "424": "Pacific Standard Time",
    "425": "Pacific Standard Time",
    "428": "Atlantic Standard Time",
    "430": "Central Standard Time",
    "431": "Central Standard Time",
    "432": "Central Standard Time",
    "434": "Eastern Standard Time",
    "435": "Mountain Standard Time",
    "436": "Eastern Standard Time",
    "437": "Eastern Standard Time",
    "438": "Eastern Standard Time",
    "440": "Eastern Standard Time",
    "442": "Pacific Standard Time",
    "443": "Eastern Standard Time",
    "445": "Eastern Standard Time",
    "447": "Central Standard Time",
    "448": "Central Standard Time",
    "450": "Eastern Standard Time",
    "456": "N/A",
    "458": "Pacific Standard Time",
    "463": "Eastern Standard Time",
    "464": "Central Standard Time",
    "468": "Eastern Standard Time",
    "469": "Central Standard Time",
    "470": "Eastern Standard Time",
    "472": "Eastern Standard Time",
    "474": "Mountain Standard Time",
    "475": "Eastern Standard Time",
    "478": "Eastern Standard Time",
    "479": "Central Standard Time",
    "480": "Mountain Standard Time",
    "484": "Eastern Standard Time",
    "500": "N/A",
    "501": "Central Standard Time",
    "502": "Eastern Standard Time",
    "503": "Pacific Standard Time",
    "504": "Central Standard Time",
    "505": "Mountain Standard Time",
    "506": "Atlantic Standard Time",
    "507": "Central Standard Time",
    "508": "Eastern Standard Time",
    "509": "Pacific Standard Time",
    "510": "Pacific Standard Time",
    "512": "Central Standard Time",
    "513": "Eastern Standard Time",
    "514": "Eastern Standard Time",
    "515": "Central Standard Time",
    "516": "Eastern Standard Time",
    "517": "Eastern Standard Time",
    "518": "Eastern Standard Time",
    "519": "Eastern Standard Time",
    "520": "Mountain Standard Time",
    "521": "N/A",
    "522": "N/A",
    "523": "N/A",
    "524": "N/A",
    "528": "N/A",
    "529": "N/A",
    "530": "Pacific Standard Time",
    "531": "Central Standard Time",
    "533": "N/A",
    "534": "Central Standard Time",
    "539": "Central Standard Time",
    "540": "Eastern Standard Time",
    "541": "Pacific Standard Time",
    "544": "N/A",
    "548": "Eastern Standard Time",
    "551": "Eastern Standard Time",
    "557": "Central Standard Time",
    "559": "Pacific Standard Time",
    "561": "Eastern Standard Time",
    "562": "Pacific Standard Time",
    "563": "Central Standard Time",
    "564": "Pacific Standard Time",
    "566": "N/A",
    "567": "Eastern Standard Time",
    "570": "Eastern Standard Time",
    "571": "Eastern Standard Time",
    "572": "Central Standard Time",
    "573": "Central Standard Time",
    "574": "Eastern Standard Time",
    "575": "Mountain Standard Time",
    "579": "Eastern Standard Time",
    "580": "Central Standard Time",
    "581": "Eastern Standard Time",
    "582": "Eastern Standard Time",
    "584": "Central Standard Time",
    "585": "Eastern Standard Time",
    "586": "Eastern Standard Time",
    "587": "Mountain Standard Time",
    "588": "N/A",
    "601": "Central Standard Time",
    "602": "Mountain Standard Time",
    "603": "Eastern Standard Time",
    "604": "Pacific Standard Time",
    "605": "Central Standard Time",
    "606": "Eastern Standard Time",
    "607": "Eastern Standard Time",
    "608": "Central Standard Time",
    "609": "Eastern Standard Time",
    "610": "Eastern Standard Time",
    "611": "N/A",
    "612": "Central Standard Time",
    "613": "Eastern Standard Time",
    "614": "Eastern Standard Time",
    "615": "Central Standard Time",
    "616": "Eastern Standard Time",
    "617": "Eastern Standard Time",
    "618": "Central Standard Time",
    "619": "Pacific Standard Time",
    "620": "Central Standard Time",
    "622": "N/A",
    "623": "Mountain Standard Time",
    "624": "Eastern Standard Time",
    "626": "Pacific Standard Time",
    "628": "Pacific Standard Time",
    "629": "Central Standard Time",
    "630": "Central Standard Time",
    "631": "Eastern Standard Time",
    "636": "Central Standard Time",
    "639": "Mountain Standard Time",
    "640": "Eastern Standard Time",
    "641": "Central Standard Time",
    "645": "Eastern Standard Time",
    "646": "Eastern Standard Time",
    "647": "Eastern Standard Time",
    "650": "Pacific Standard Time",
    "651": "Central Standard Time",
    "656": "Eastern Standard Time",
    "657": "Pacific Standard Time",
    "659": "Central Standard Time",
    "660": "Central Standard Time",
    "661": "Pacific Standard Time",
    "662": "Central Standard Time",
    "667": "Eastern Standard Time",
    "669": "Pacific Standard Time",
    "672": "Pacific Standard Time",
    "678": "Eastern Standard Time",
    "680": "Eastern Standard Time",
    "681": "Eastern Standard Time",
    "682": "Central Standard Time",
    "683": "Eastern Standard Time",
    "686": "Eastern Standard Time",
    "689": "Eastern Standard Time",
    "700": "N/A",
    "701": "Central Standard Time",
    "702": "Pacific Standard Time",
    "703": "Eastern Standard Time",
    "704": "Eastern Standard Time",
    "705": "Eastern Standard Time",
    "706": "Eastern Standard Time",
    "707": "Pacific Standard Time",
    "708": "Central Standard Time",
    "709": "Atlantic Standard Time",
    "710": "N/A",
    "712": "Central Standard Time",
    "713": "Central Standard Time",
    "714": "Pacific Standard Time",
    "715": "Central Standard Time",
    "716": "Eastern Standard Time",
    "717": "Eastern Standard Time",
    "718": "Eastern Standard Time",
    "719": "Mountain Standard Time",
    "720": "Mountain Standard Time",
    "724": "Eastern Standard Time",
    "725": "Pacific Standard Time",
    "726": "Central Standard Time",
    "727": "Eastern Standard Time",
    "728": "Eastern Standard Time",
    "730": "Central Standard Time",
    "731": "Central Standard Time",
    "732": "Eastern Standard Time",
    "734": "Eastern Standard Time",
    "737": "Central Standard Time",
    "740": "Eastern Standard Time",
    "742": "Eastern Standard Time",
    "743": "Eastern Standard Time",
    "747": "Pacific Standard Time",
    "753": "Eastern Standard Time",
    "754": "Eastern Standard Time",
    "757": "Eastern Standard Time",
    "760": "Pacific Standard Time",
    "762": "Eastern Standard Time",
    "763": "Central Standard Time",
    "765": "Eastern Standard Time",
    "769": "Central Standard Time",
    "770": "Eastern Standard Time",
    "771": "Eastern Standard Time",
    "772": "Eastern Standard Time",
    "773": "Central Standard Time",
    "774": "Eastern Standard Time",
    "775": "Pacific Standard Time",
    "778": "Pacific Standard Time",
    "779": "Central Standard Time",
    "780": "Mountain Standard Time",
    "781": "Eastern Standard Time",
    "782": "Atlantic Standard Time",
    "785": "Central Standard Time",
    "786": "Eastern Standard Time",
    "800": "N/A",
    "801": "Mountain Standard Time",
    "802": "Eastern Standard Time",
    "803": "Eastern Standard Time",
    "804": "Eastern Standard Time",
    "805": "Pacific Standard Time",
    "806": "Central Standard Time",
    "807": "Eastern Standard Time",
    "808": "HAST",
    "809": "AST",
    "810": "Eastern Standard Time",
    "812": "Eastern Standard Time",
    "813": "Eastern Standard Time",
    "814": "Eastern Standard Time",
    "815": "Central Standard Time",
    "816": "Central Standard Time",
    "817": "Central Standard Time",
    "818": "Pacific Standard Time",
    "819": "Eastern Standard Time",
    "820": "Pacific Standard Time",
    "825": "Mountain Standard Time",
    "826": "Eastern Standard Time",
    "828": "Eastern Standard Time",
    "830": "Central Standard Time",
    "831": "Pacific Standard Time",
    "832": "Central Standard Time",
    "833": "N/A",
    "835": "Eastern Standard Time",
    "838": "Eastern Standard Time",
    "839": "Eastern Standard Time",
    "840": "Pacific Standard Time",
    "843": "Eastern Standard Time",
    "844": "N/A",
    "845": "Eastern Standard Time",
    "847": "Central Standard Time",
    "848": "Eastern Standard Time",
    "850": "Central Standard Time",
    "854": "Eastern Standard Time",
    "855": "N/A",
    "856": "Eastern Standard Time",
    "857": "Eastern Standard Time",
    "858": "Pacific Standard Time",
    "859": "Eastern Standard Time",
    "860": "Eastern Standard Time",
    "861": "Central Standard Time",
    "862": "Eastern Standard Time",
    "863": "Eastern Standard Time",
    "864": "Eastern Standard Time",
    "865": "Eastern Standard Time",
    "866": "N/A",
    "867": "Pacific Standard Time",
    "870": "Central Standard Time",
    "872": "Central Standard Time",
    "873": "Eastern Standard Time",
    "877": "N/A",
    "878": "Eastern Standard Time",
    "879": "Atlantic Standard Time",
    "880": "N/A",
    "881": "N/A",
    "888": "N/A",
    "900": "N/A",
    "901": "Central Standard Time",
    "902": "Atlantic Standard Time",
    "903": "Central Standard Time",
    "904": "Eastern Standard Time",
    "905": "Eastern Standard Time",
    "906": "Eastern Standard Time",
    "907": "AKST",
    "908": "Eastern Standard Time",
    "909": "Pacific Standard Time",
    "910": "Eastern Standard Time",
    "912": "Eastern Standard Time",
    "913": "Central Standard Time",
    "914": "Eastern Standard Time",
    "915": "Mountain Standard Time",
    "916": "Pacific Standard Time",
    "917": "Eastern Standard Time",
    "918": "Central Standard Time",
    "919": "Eastern Standard Time",
    "920": "Central Standard Time",
    "925": "Pacific Standard Time",
    "928": "Mountain Standard Time",
    "929": "Eastern Standard Time",
    "930": "Eastern Standard Time",
    "931": "Central Standard Time",
    "934": "Eastern Standard Time",
    "936": "Central Standard Time",
    "937": "Eastern Standard Time",
    "938": "Central Standard Time",
    "940": "Central Standard Time",
    "941": "Eastern Standard Time",
    "943": "Eastern Standard Time",
    "945": "Central Standard Time",
    "947": "Eastern Standard Time",
    "948": "Eastern Standard Time",
    "949": "Pacific Standard Time",
    "951": "Pacific Standard Time",
    "952": "Central Standard Time",
    "954": "Eastern Standard Time",
    "956": "Central Standard Time",
    "959": "Eastern Standard Time",
    "970": "Mountain Standard Time",
    "971": "Pacific Standard Time",
    "972": "Central Standard Time",
    "973": "Eastern Standard Time",
    "975": "Central Standard Time",
    "978": "Eastern Standard Time",
    "979": "Central Standard Time",
    "980": "Eastern Standard Time",
    "983": "Mountain Standard Time",
    "984": "Eastern Standard Time",
    "985": "Central Standard Time",
    "986": "Mountain Standard Time",
    "989": "Eastern Standard Time"
};
